import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'coment.input.placeholder',
    defaultMessage: 'Write a public comment',
  },
  addComment: {
    id: 'comment.input.add',
    defaultMessage: 'Add Comment',
  },
  noComments: {
    id: 'comment.nocomment',
    defaultMessage: 'No comments yet. Why don\'t you leave first comment?',
  },
  notSignedIn: {
    id: 'comment.not.signed',
    defineMessages: 'Please sign in to leave comments.',
  },
})
